import qrcode from 'qrcode';
import { handleAuthResponse } from '../auth';


export const read = (userId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getSDSICMerch = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/shirtList`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getFullUserList = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/allPendingUsers`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
        }        
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const updateUserRole = (userId, role, token) => {
    
    return fetch(`${process.env.REACT_APP_API_URL}/user/updaterole/${userId}`, {
        method: 'POST',
        credentials: 'include',
        'headers': {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({role: role})
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getMerchArticle = (articleId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/articles/${articleId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const sendMessage = async (message) => {

    return fetch(`${process.env.REACT_APP_API_URL}/mail/sendServerEmail`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(message)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



export const update = (userId, token, user) => {
    
    return fetch(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(user)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const remove = (userId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/user/${userId}`, {
        method: "DELETE",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const list = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/users`, {
        method: "GET",
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const listForGroup = (groupId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/users/forgroup/${groupId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// export const updateUser = (user, next) => {
//     if (typeof window !== "undefined") {
//         if (localStorage.getItem("jwt")) {
//             let auth = JSON.parse(localStorage.getItem("jwt"));
//             auth.user = user;
//             localStorage.setItem("jwt", JSON.stringify(auth));
//             next();
//         }
//     }
// };

export const updateUser = (user, next) => {
    if (typeof window !== "undefined") {
        const raw = localStorage.getItem("user");
        if (raw) {
            let stored = JSON.parse(raw);
            stored = { ...stored, ...user };
            localStorage.setItem("user", JSON.stringify(stored));
            next();
        }
    }
};

export const follow = (userId, token, followId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/user/follow`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, followId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const unfollow = (userId, token, unfollowId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/user/unfollow`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, unfollowId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const findPeople = (userId, searchText, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/user/findpeople/${userId}?searchText=${searchText}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const mfa_qr_code = async (req, res) =>{
    return fetch(`${process.env.REACT_APP_API_URL}/user/generateQRCode/5e2611483f99fa3bb4dd922a`, {
        method: "GET",
        credentials: 'include',
        headers: {
            // Accept: "application/json",
            "Content-Type": "image/png"
        }
    })
        .then(response => {
            return response;
        })
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
}